import { EventKind } from "@nova/schemas"
import { NotifiableEventKind } from "@nova/notifications"
import { ProcessingNotification } from "./ProcessingNotification"
import { StreamNotification } from "./StreamNotification"
import { AccessGrantedNotification, AccessRequestedNotification } from "./AccessNotification"
import { CommentNotification } from "./CommentNotification"
import { LocationSharingNotification } from "./LocationSharingNotification"
import { NotificationKindProps } from "./types"

export const notificationComponentByKind: {
    [K in NotifiableEventKind]: (props: NotificationKindProps<K>) => React.ReactNode
} = {
    [EventKind.LayerProcessed]: ProcessingNotification,
    [EventKind.LayerProcessingFailed]: ProcessingNotification,
    [EventKind.StreamStarted]: StreamNotification,
    [EventKind.StreamShared]: StreamNotification,
    [EventKind.MissionGroupStreamShared]: StreamNotification,
    [EventKind.MissionGroupDashboardShared]: StreamNotification,
    [EventKind.AccessRequested]: AccessRequestedNotification,
    [EventKind.AccessGranted]: AccessGrantedNotification,
    [EventKind.CommentCreated]: CommentNotification,
    [EventKind.LocationSharingStarted]: LocationSharingNotification,
    [EventKind.LocationSharingEnded]: LocationSharingNotification,
}
